import type { Capability } from '@taler/api-client'

/**
 * `MerchantController`'s own KDoc: "Reads are gated on ENTRY_VIEW_ALL (the list is every
 * payee in the ledger)" - unlike the journal view itself, there is no `_OWN` counterpart,
 * since a payee directory is cross-user by nature. `ENTRY_VIEW_OWN` alone 403s on
 * `merchants_list`.
 */
export function canViewMerchants(can: (capability: Capability) => boolean): boolean {
  return can('ENTRY_VIEW_ALL')
}

/** Aliasing and merging are financial-record edits gated on RECORDS_MANAGE, same reasoning
 * as loans/contacts/targets - there is no dedicated capability for either operation. */
export function canManageMerchants(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
